/**
 * @generated SignedSource<<8af4f8a1d0ab8b2796b4af557e4e08d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v2 = {
  "kind": "Variable",
  "name": "offerId",
  "variableName": "offerId"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "scope"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scope",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "variables",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rootDocumentId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "top",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "right",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bottom",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "left",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Padding",
  "kind": "LinkedField",
  "name": "padding",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "WidgetDates",
  "kind": "LinkedField",
  "name": "dates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastUpdate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breakPage",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "DocumentWidget",
  "kind": "LinkedField",
  "name": "widgets",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "widgetId",
      "storageKey": null
    },
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentWidgetRule",
      "kind": "LinkedField",
      "name": "rules",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "action",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DocumentWidgetRuleCondition",
          "kind": "LinkedField",
          "name": "conditions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "condition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "variable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "operator",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = [
  (v19/*: any*/),
  (v15/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "DocumentSection",
  "kind": "LinkedField",
  "name": "pages",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Padding",
      "kind": "LinkedField",
      "name": "padding",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v12/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentWidgetRow",
      "kind": "LinkedField",
      "name": "widgets",
      "plural": true,
      "selections": [
        (v19/*: any*/),
        (v18/*: any*/),
        (v15/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentWidgetHeaderFooter",
      "kind": "LinkedField",
      "name": "header",
      "plural": true,
      "selections": (v20/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentWidgetHeaderFooter",
      "kind": "LinkedField",
      "name": "footer",
      "plural": true,
      "selections": (v20/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemScope",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemType",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "major",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minor",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comments",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectionReason",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": [
    (v2/*: any*/)
  ],
  "concreteType": "RawDocument",
  "kind": "LinkedField",
  "name": "rawDocuments",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filename",
      "storageKey": null
    },
    (v5/*: any*/),
    (v7/*: any*/),
    (v6/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QAllDocumentsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Document",
        "kind": "LinkedField",
        "name": "allDocuments",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReviewComment",
                "kind": "LinkedField",
                "name": "reviewComments",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "offerVersion",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v28/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v31/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QAllDocumentsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Document",
        "kind": "LinkedField",
        "name": "allDocuments",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReviewComment",
                "kind": "LinkedField",
                "name": "reviewComments",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v24/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "offerVersion",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v28/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v31/*: any*/)
    ]
  },
  "params": {
    "cacheID": "a7af0d088a5de589030f1e83b106fd54",
    "id": null,
    "metadata": {},
    "name": "QAllDocumentsQuery",
    "operationKind": "query",
    "text": "query QAllDocumentsQuery(\n  $scope: DocumentScopeEnum!\n  $offerId: ID\n) {\n  allDocuments(scope: $scope, offerId: $offerId) {\n    id\n    name\n    scope\n    offerId\n    variables\n    rootDocumentId\n    sourceName\n    padding {\n      top\n      right\n      bottom\n      left\n    }\n    type\n    dates {\n      creation\n      lastUpdate\n    }\n    pages {\n      breakPage\n      padding {\n        top\n        bottom\n        left\n        right\n      }\n      widgets {\n        widgets {\n          widgetId\n          type\n          rules {\n            action\n            conditions {\n              condition\n              variable\n              value\n              operator\n            }\n          }\n        }\n        breakPage\n        padding {\n          top\n          right\n          bottom\n          left\n        }\n      }\n      header {\n        widgets {\n          widgetId\n          type\n          rules {\n            action\n            conditions {\n              condition\n              variable\n              value\n              operator\n            }\n          }\n        }\n        padding {\n          top\n          right\n          bottom\n          left\n        }\n      }\n      footer {\n        widgets {\n          widgetId\n          type\n          rules {\n            action\n            conditions {\n              condition\n              variable\n              value\n              operator\n            }\n          }\n        }\n        padding {\n          top\n          right\n          bottom\n          left\n        }\n      }\n    }\n    version {\n      versionId\n      itemId\n      status\n      itemScope\n      itemType\n      major\n      minor\n      reviewComments {\n        comments\n        rejectionReason\n        status\n        id\n      }\n      id\n    }\n    offerVersion {\n      major\n      minor\n      id\n    }\n  }\n  rawDocuments(offerId: $offerId) {\n    id\n    filename\n    name\n    offerId\n    scope\n    dates {\n      creation\n      lastUpdate\n    }\n  }\n}\n"
  }
};
})();

node.hash = "b8cf528c609f5899e9997a3779809885";

export default node;
